var $cc82b5cf91ddc409$exports = {};
$cc82b5cf91ddc409$exports = {
    "loading": `\u{6B63}\u{5728}\u{52A0}\u{8F7D}...`,
    "loadingMore": `\u{6B63}\u{5728}\u{52A0}\u{8F7D}\u{66F4}\u{591A}...`
};


export {$cc82b5cf91ddc409$exports as default};
//# sourceMappingURL=zh-CN.module.js.map
